export default __webpack_public_path__ + "static/media/132089728_1031910864255779_4909379516583769270_n.bcaa991c.jpg";